<template>
  <div class="questions-list text-center">
    <h3>Hääletused</h3>

    <div v-if="isBusy">
      <div class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Hääletusi laetakse..</strong>
      </div>
    </div>

    <div v-else v-for="question in questions" :key="question.id" class="question-item" @click="goToVote(question.id)">
      <h4>{{ question.question }}</h4>
      <b-img class="vote-icon" :src="question.sponsor_logo"></b-img>
    </div>

    <div v-if="!isBusy && !questions.length">
      <h6>Hetkel aktiivseid hääletusi ei ole, tulge hiljem tagasi</h6>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "QuestionsListing",
  data() {
    return {
      questions: [],
      isBusy: true
    }
  },
  mounted() {
    this.fetchQuestions();
  },
  methods: {
    fetchQuestions() {
      axios
        .get(process.env.VUE_APP_BACKEND_HOST + "/api/v1/voting/questions")
        .then((response) => {
          if (response.data.length === 1) {
            this.goToVote(response.data[0].id);
            return;
          }

          response.data.map((question) => {
            this.questions.push(
              {
                id: question.id,
                question: question.question,
                sponsor_logo: question.sponsor_logo
              }
            );
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    goToVote(id) {
      this.$router.push("/voting/" + id);
    }
  }
};
</script>
